module.exports = __webpack_public_path__ + "img/user.2553acb9.png";